const INVITATION_CODE_LENGTH = 8;

export function compactInvitationCode(rawCode: string | undefined): string {
  return (rawCode ?? '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase().slice(0, INVITATION_CODE_LENGTH);
}

export function formatInvitationCode(rawCode: string | undefined): string {
  const compact = compactInvitationCode(rawCode);
  if (compact.length <= 4) return compact;
  return `${compact.slice(0, 4)}-${compact.slice(4)}`;
}

export function normalizeInvitationCode(rawCode: string | undefined): string | undefined {
  const formatted = formatInvitationCode(rawCode);
  return formatted.length === 9 ? formatted : undefined;
}
